import { List } from "@mui/material";
import { navTopConfigurations } from "../../configuration/navTopConfiguration";
import { NavTopMenu } from "../NavTopMenu";

export default function NavTopMenus() {
  return (
    <List sx={{ paddingBottom: "32px" }}>
      {navTopConfigurations.map((nav) => (
        <NavTopMenu topNavigation={nav} key={nav.id} />
      ))}
    </List>
  );
}
